import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
	flexJustify?: 'default'|'bottom';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InputGroup',
  props: {
    flexJustify: { default: "default" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`input-group input-group--justify-${_ctx.flexJustify}`)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})